var _clipPath, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEvaluation = function SvgEvaluation(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102 102",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166670224706634704170000011905842209305627799_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h100v100H1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000166670224706634704170000011905842209305627799_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 1H1.6c-.1 0-.3.1-.4.2s-.2.3-.2.4V41c0 .2.1.3.2.4s.3.2.4.2h5c.2 0 .3-.1.4-.2s.2-.3.2-.4V7.9c0-.2.1-.3.2-.4s.3-.2.4-.2H94c.2 0 .3.1.4.2s.2.3.2.4v86.3c0 .2-.1.3-.2.4s-.3.2-.4.2H61c-.2 0-.3.1-.4.2s-.2.3-.2.4v5c0 .2.1.3.2.4s.3.2.4.2h39.4c.2 0 .3-.1.4-.2s.2-.3.2-.4V1.6c0-.2-.1-.3-.2-.4s-.3-.2-.4-.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 47.9H23.5c-.2 0-.3.1-.4.2s-.2.3-.2.4v5c0 .2.1.3.2.4s.3.2.4.2h17.1L7.3 89.9V73.5c0-.2-.1-.3-.2-.4s-.3-.2-.4-.2h-5c-.2 0-.3.1-.4.2s-.2.3-.2.4v26.9c0 .2.1.3.2.4s.3.2.4.2h26.9c.2 0 .3-.1.4-.2s.2-.3.2-.4v-5c0-.2-.1-.3-.2-.4s-.3-.2-.4-.2H11.4l33.4-36v16.7c0 .2.1.3.2.4s.3.2.4.2h5c.2 0 .3-.1.4-.2s.2-.3.2-.4v-27c0-.1 0-.2-.1-.3 0-.1-.1-.2-.2-.2-.1-.1-.1-.1-.2-.1z"
  }))));
};
export default SvgEvaluation;